import React, { useState, useEffect } from 'react';
import Modal from "react-modal";
import NiceModal from "@ebay/nice-modal-react";
import { Oval } from "react-loader-spinner";
import { safeLocalStorage } from '@utils/localstorage';
import { useDispatch } from 'react-redux';
import * as actionTypes from "@redux/actionTypes";
import { useRouter } from "next/router";
import { getBotDetails, getMissions } from "@services/api";
import { toast } from "react-toastify";
import toastErrorMessages from "@util/toastErrorMessage";
import SignInModal from "../SignInModal";
import ActivateTestDriveModal from "@components/Modal/ActivateTestDriveModal"

const TestDriveButton = () => {
    const router = useRouter();
    const dispatch = useDispatch();
    const user = safeLocalStorage.getItem("token")
    const [isLoading, setIsLoading] = useState(false);
    const [botLogInOpen, setbotLogInOpen] = useState(false);

    // useEffect(() => {
    //     if (user) {
    //         const checkActivationTimePeriod = isWithinActivationPeriod()
    //         if (!checkActivationTimePeriod) {
    //             activationCodeHandler();
    //         }
    //     }
    // }, [user])

    const activationCodeHandler = () => {
        NiceModal.show(ActivateTestDriveModal, { playgameHandler })
    }

    const isWithinActivationPeriod = () => {
        const currentTime = new Date();

        if (user && user?.user_activations && user?.user_activations?.length > 0) {
            for (const activation of user?.user_activations) {
                const startTime = new Date(activation?.start_time);
                const endTime = new Date(activation?.end_time);

                if (currentTime >= startTime && currentTime <= endTime) {
                    return true;
                }
            }
        }

        return false;
    };

    const playgameHandler = async () => {
        setIsLoading(true)
        const allBots = await getBotDetails();
        try {
            if (allBots?.length > 0) {
                const test_ready = allBots?.filter((i) => i.status === "test_ready" && i.drive_mode === 'trial');
                if (test_ready?.length > 0) {
                    findDeviceId(test_ready);
                } else {
                    dispatch({
                        type: actionTypes.NO_TESTDRIVE_BOT,
                        payload: true,
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.NO_TESTDRIVE_BOT,
                    payload: true,
                });
            }
        } catch (error) {
            dispatch({
                type: actionTypes.NO_TESTDRIVE_BOT,
                payload: true,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const findDeviceId = async (test_ready) => {
        const randomBotChioce = await getRandomBotChioce(test_ready);
        if (randomBotChioce) {
            await checkMissionData(randomBotChioce)
        }
    };

    const getRandomBotChioce = (test_ready) => {
        const randomIndex = Math.floor(Math.random() * test_ready?.length);
        return test_ready[randomIndex];
    };

    const checkMissionData = async (randomBotChioce) => {
        const mission = await getMissions(randomBotChioce.device_ref_id)
        if (mission?.data?.missions?.length > 0) {
            const findPveMission = mission?.data?.missions.find((i) => i?.type === 'pve')
            if (findPveMission?.id) {
                const tournamentData = {
                    deviceId: randomBotChioce?.device_ref_id,
                    hardware_version: randomBotChioce?.hardware_version,
                    speed_control_profile: randomBotChioce?.speed_control_profile && Object.keys(randomBotChioce?.speed_control_profile).length > 0
                        ? randomBotChioce?.speed_control_profile
                        : ''
                };
                safeLocalStorage.setItem("tournamentData", tournamentData);
                router.push("/testdrivecontroller");
                setIsLoading(false)
            } else {
                toast.error(toastErrorMessages.missionNotFound, { position: "top-right" })
            }
        } else if (mission?.data?.error) {
            toast.error(`${mission?.data?.error}`, { position: "top-right" });
        }
    }

    const buySignHandler = () => {
        setbotLogInOpen(!botLogInOpen);
    };

    const closebuySignModel = () => {
        setbotLogInOpen(false);
    };

    return (
        <>
            <div className="button-section">
                {user ? (
                    <button className="play-test-drive-btn" onClick={playgameHandler}>
                        <p className="play-test-drive_letter">Let's GO!</p>
                        {isLoading &&
                            <Oval
                                height={25}
                                width={25}
                                color="#FFFFFF"
                                visible={isLoading}
                                ariaLabel="oval-loading"
                                secondaryColor="#000000"
                                strokeWidth={5}
                                strokeWidthSecondary={3}
                            />}
                    </button>
                ) : (
                    <button className="btn sign-btn" onClick={buySignHandler}>
                        <p className="play-via-discord_letter">Sign in/up to play!</p>
                    </button>
                )}
            </div>
            <Modal
                isOpen={botLogInOpen}
                className=" mymodal"
                ariaHideApp={false}
                onRequestClose={closebuySignModel}
            >
                <SignInModal closeSignInModel={closebuySignModel} />
            </Modal>
        </>
    );
}

export default TestDriveButton;